import React, { StrictMode } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import routes from 'app/routes';
import useEnterpriseBriefs from 'components/Common/Enterprises/Hooks/useEnterpriseBriefs';
import List from './Pages/List/Index';
import NewBrief from './Pages/New/Index';
import EditBrief from './Pages/Edit/Index';

export default function Index({ enterpriseId }) {
  const [briefs, refresh] = useEnterpriseBriefs({ enterpriseId });

  const router = createBrowserRouter([
    {
      path: routes.admin.enterprise_briefs.index(enterpriseId),
      element: <List enterpriseId={enterpriseId} briefs={briefs} refresh={refresh} />,
      children: [
        {
          path: routes.admin.enterprise_briefs.new(enterpriseId),
          element: <NewBrief enterpriseId={enterpriseId} refresh={refresh} />,
        },
        {
          path: routes.admin.enterprise_briefs.edit(enterpriseId),
          element: <EditBrief enterpriseId={enterpriseId} refresh={refresh} />,
        },
      ],
    },
  ]);

  return (
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
